module.exports = __webpack_public_path__ + "static/media/02.8ee5a9ca.jpg";